var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.removeRegions
    ? _c("div", { class: { hidden: _vm.hideRegions } }, [
        _c(
          "div",
          {
            ref: "isoregionTooltip",
            staticClass: "margin-bottom-10",
            attrs: {
              "data-tooltiptarget": ".entityTooltip",
              "data-tooltipoptions":
                "{'width':350,'hideArrow':false,'position':'right','showOverlay':true}",
            },
          },
          [
            _c("p", { staticClass: "entity__headline" }, [
              _c("label", { attrs: { for: "isoregion" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.trans("FORM_SEARCH_REGIONS")) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.regionFieldDisabled ? _vm._t("region") : _vm._e(),
            _vm._v(" "),
            _vm._t("isoregion"),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "isocountryTooltip",
            attrs: {
              "data-tooltiptarget": ".entityTooltip",
              "data-tooltipoptions":
                "{'width':350,'hideArrow':false,'position':'right','showOverlay':true}",
            },
          },
          [
            _vm.showSearchField
              ? _c(
                  "div",
                  { staticClass: "margin-bottom-10" },
                  [
                    _c(
                      "p",
                      {
                        staticClass: "entity__headline",
                        attrs: { id: "isocountriesTitle" },
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "required",
                            attrs: { for: "isocountries" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.locale !== "en"
                                  ? _vm.trans(
                                      "ACCOUNT_FAST_REGISTRATION_COUNTRY"
                                    )
                                  : _vm.trans("FORM_COUNTRIES_TERRITORIES")
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("select-searchable", {
                      attrs: {
                        id: "isocountries",
                        options: _vm.filteredCountries,
                        disabled: _vm.allFiltersDisabled,
                        "option-id-prefix": "isocountry_",
                        name: "isocountries[]",
                        "search-placeholder": _vm.trans("FORM_COUNTRY_SEARCH"),
                        "search-name": "isocountrySearch",
                        "search-id": "isocountrySearch",
                        "search-input-labelled-by": "isocountriesTitle",
                      },
                      on: { select: _vm.setSelectedCountry },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }